import actions from './actions';
import getters from './getters';
import mutations from './mutations';

const state = {
  links: [],
  link: false,
  error: false,
  success: false,
  loading: false,
  exportLoading: false,
  exportSuccess: false,
  downloadLink: '',
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};



// WEBPACK FOOTER //
// ./src/components/Syndicates/Syndicate/Links/index.js